import { render } from "./CompareOverview.vue?vue&type=template&id=2e8c7608"
import script from "./CompareOverview.vue?vue&type=script&lang=js"
export * from "./CompareOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__